import React from "react";
import TextLoop from "react-text-loop";
import Fade from "react-reveal/Fade";

const conctInfo = {
  phone: "+91 8107 958922",
  email: "laksh.parnami@gmail.com",
};

const sliderContent = {
  name: "Lakshay Parnami",
  designation: "Full-stack Developer",
  description: `I develop mobile applications for of all formats,
  specializing in creating scalable, and developer friendly architectures.`,
  btnText: "Download Resume",
};

const Slider = () => {
  return (
    <>
      {/*  Home Banner */}
      <section id="home" className="home-banner">
        <div className="hb-top-fixed d-flex">
          <div className="hb-info">
            <a href="tel:+918107958922">{conctInfo.phone}</a>
            <a href="mailto:laksh.parnami@gmail.com">
              {conctInfo.email}
            </a>
          </div>
          {/* <div className="hb-lang">
            <ul className="nav">
              <li className="active">
                <a href="#">EN</a>
              </li>
              <li>
                <a href="#">FR</a>
              </li>
            </ul>
          </div> */}
        </div>
        {/* End hp-top-fixed */}

        <div className="container">
          <div className="row full-screen align-items-center">
            <div className="col-lg-7">
              <div className="type-box">
                <Fade bottom>
                  <h6>Hello, My name is</h6>
                  <h1 className="font-alt">{sliderContent.name}</h1>
                  <TextLoop>
                    <p className="loop-text lead">Android Developer</p>
                    <p className="loop-text lead">Flutter App Developer</p>
                    <p className="loop-text lead">React Developer</p>
                  </TextLoop>{" "}
                  <p className="desc">{sliderContent.description}</p>
                  <div className="mt-4">
                    <a
                      className="px-btn px-btn-white"
                      href="resume-lakshay-parnami.pdf"
                      download
                    >
                      {sliderContent.btnText}
                    </a>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
        {/* End Container*/}
        <div
          className="hb-me"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL + "img/slider/home-banner.png"
              })`,
          }}
        ></div>
      </section>

      {/* End Home Banner  */}
    </>
  );
};

export default Slider;
